import React from 'react';
import { useSelector } from 'react-redux';

import pickOpendateLogoVariant from '../utils/pickOpendateLogoVariant';

const PoweredByLogo = () => {
  const backgroundColor = useSelector((state) => {
    const themeApplies = state.widgetType === 'custom' && !state.useDefaultTheme;

    if (!themeApplies) return '#ffffff';

    return (state.widgetConfig && state.widgetConfig.background_color) || '#ffffff';
  });

  return (
    <a href="https://www.opendate.io/" target="_blank" rel="noreferrer">
      <img src={pickOpendateLogoVariant(backgroundColor)}
           className="ml-2"
           style={{ width: '88px' }} />
    </a>
  );
};

export default PoweredByLogo;
